export default "__VITE_ASSET__CIigsl4k__"